import StitchFeaturePage from "../../components/sections/StitchFeaturePage";

const features = [
  { title: "Custom Theme Builds", desc: "Pixel-precise, lightweight themes engineered for speed and maintainability." },
  { title: "Plugin Architecture", desc: "Custom modules and integrations without bloated dependencies or fragile hacks." },
  { title: "Security Hardening", desc: "Proactive hardening and permission controls to reduce operational risk." },
  { title: "Performance Tuning", desc: "Caching, asset strategy, and code cleanup for consistently fast experiences." },
  { title: "Editorial UX", desc: "CMS workflows built for content teams so publishing stays fast and reliable." },
  { title: "Commerce Enablement", desc: "WooCommerce implementations optimized for conversion and order operations." },
];

const WordPress = () => (
  <StitchFeaturePage
    label="WEB & DIGITAL"
    title="WordPress engineered"
    titleAccent="for scale."
    subtitle="From marketing sites to content-heavy platforms, we build WordPress systems that stay fast and secure."
    features={features}
    ctaLabel="START WORDPRESS BUILD"
  />
);

export default WordPress;